autoslash.createNamespace("autoslash.modals");
autoslash.register(autoslash.modals);

// Displays a message in the shared #msg-modal (see _BootstrapModal.cshtml).
// severity: "error" | "warning" | "success" | "info" — drives the header background class.
autoslash.modals.show = function (title, message, severity) {
    "use strict";
    var severityClass = {
        error: "bg-danger",
        warning: "bg-warning",
        success: "bg-success",
        info: "bg-info"
    }[severity] || "bg-info";

    var modal = $("#msg-modal");
    modal.find(".modal-header").removeClass("bg-danger bg-warning bg-success bg-info").addClass(severityClass);
    modal.find(".modal-title").text(title);
    modal.find(".msg-content").text(message);
    modal.modal();
}
